import { lms_v2_api } from "../../../services/cs-lab-config"

function getAiChatResponse(payload) {
    return lms_v2_api.post("/ideProjects/aiChatBot/",payload);
}

function transcribeAudioToText(audioFile) {

    const formData = new FormData();
    formData.append('file', audioFile, 'recording.webm');

    return lms_v2_api.post("/chatbot/transcribeAudioToText/", formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
    });
}

export { getAiChatResponse, transcribeAudioToText }